<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="biosecurityIncidentForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="biosecurityIncident" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                biosecurityIncidentForm: () => import('../forms/BiosecurityIncidentForm'),
                biosecurityIncident: () => import('../editViews/BiosecurityIncident'),
                headers: [
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Contact', value: 'contactId', table: 'contacts', form: () => import('../forms/ContactForm') },
                    { text: 'Coordinates', value: 'coordinates', format: this.formatCoordinates },
                    { text: 'Affliction', value: 'afflictionId', table: 'afflictions', form: () => import('../forms/AfflictionForm') },
                    { text: 'Inspection', value: 'inspectionId', table: 'inspections', form: () => import('../forms/InspectionForm') },
                    { text: 'Comments', value: 'comments' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    afflictions: [],
                    contacts: [],
                    inspections: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "afflictionId", direction: "ascending" },
                ],
                itemsField: 'biosecurityIncidents',
                editPageName: 'biosecurityIncident',
                apiMethod: 'BiosecurityIncidents',
                claimName: 'BiosecurityIncidents',
                formTitle: 'Biosecurity Incident',
                excelTitle: 'Biosecurity Incidents',
                hasEditPage: true,
            }
        },
    };
</script>
